module.exports = __webpack_public_path__ + "static/1-4122b5c894a0e593feef71e226717854.jpg";